module.exports = __webpack_public_path__ + "img/container&-van-truck.78786ad4.png";